// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tracking-table__no-results-caption_f1c07a6e{color:#84919b;font-size:14px}", ""]);
// Exports
export var trackingTableNoResultsCaption = "tracking-table__no-results-caption_f1c07a6e";
export default ___CSS_LOADER_EXPORT___;
